<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-poem"><a id="page_1"></a><a id="page_2"><em>By the Same Author:</em></a></p><a id="page_2">
<p class="fm-poem1">“SERGEANT BEEF” NOVELS:</p>
<p class="fm-poem0">Case for Three Detectives</p>
<p class="fm-poem0">Case without a Corpse</p>
<p class="fm-poem0">Case with No Conclusion</p>
<p class="fm-poem0">Case with Four Clowns</p>
<p class="fm-poem0">Case with Ropes and Rings</p>
<p class="fm-poem0">Case for Sergeant Beef</p>
<p class="fm-poem0">Cold Blood</p>
<p class="fm-poem2">“CAROLUS DEENE” NOVELS:</p>
<p class="fm-poem0">At Death’s Door</p>
<p class="fm-poem0">Death of Cold</p>
<p class="fm-poem0">Death for a Ducat</p>
<p class="fm-poem0">Dead Man’s Shoes</p>
<p class="fm-poem0">A Louse for the Hangman</p>
<p class="fm-poem0">Our Jubilee is Death</p>
<p class="fm-poem0">Jack on the Gallows Tree</p>
<p class="fm-poem0">Furious Old Women</p>
<p class="fm-poem0">A Bone and a Hank of Hair</p>
<p class="fm-poem0">Die All, Die Merrily</p>
<p class="fm-poem0">Nothing Like Blood</p>
<p class="fm-poem0">Such is Death</p>
<p class="fm-poem2">CAROLUS DEENE “DEATH” NOVELS:</p>
<p class="fm-poem0">Death at Hallows End</p>
<p class="fm-poem0">Death on the Black Sands</p>
<p class="fm-poem0">Death at St. Asprey’s School</p>
<p class="fm-poem0">Death of a Commuter</p>
<p class="fm-poem0">Death on Romney Marsh</p>
<p class="fm-poem0">Death with Blue Ribbon</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_FM.vue?7a74866a